import { render, staticRenderFns } from "./ComplaintsWithViews.vue?vue&type=template&id=595dd759&scoped=true&"
import script from "./ComplaintsWithViews.vue?vue&type=script&lang=js&"
export * from "./ComplaintsWithViews.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsWithViews.vue?vue&type=style&index=0&id=595dd759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595dd759",
  null
  
)

export default component.exports